import RfiProvider from './Rfi.provider';

export default RfiProvider;
